module.exports = "<p ng-if=\"i.region2 !== i.region1\" class=\"text-right nomargin\">{{i.region2}}</p>\n<p class=\"text-right nomargin\">{{i.region1}}</p>\n<p class=\"text-right nomargin\">{{i.country}}</p>\n<p ng-if=\"!i.country\" class=\"text-right nomargin\">?</p>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/regionspopuptemplate.html
// module id = 525
// module chunks = 0